// import { HomeContentSection, HomeContentTypes } from '@app/components/HomeModule/types/home.types'
import { HomeContentSection, HomeContentTypes } from '@app/modules/Home/Data/types'
import { fetchHomeContent } from '@app/services/homeService'
import { clientNameAtom } from '@app/state/clientsAtom'
import { homeContentAtom } from '@app/state/HomeAtoms'
import { useQuery } from '@tanstack/react-query'
import { useAtomValue, useSetAtom } from 'jotai'
import { useEffect } from 'react'

const useFetchHomeContent = () => {
  const setContent = useSetAtom(homeContentAtom)
  const clientName = useAtomValue(clientNameAtom)
  const {
    data: homeContent,
    isLoading,
    error,
    isError,
  } = useQuery<HomeContentSection>({
    queryKey: ['homeContent'],
    queryFn: () => fetchHomeContent('landingPage'),
    enabled: !!clientName,
  })

  useEffect(() => {
    if (homeContent) {
      setContent(homeContent as unknown as HomeContentTypes)
    }
  }, [homeContent, setContent, clientName])

  return { homeContent, isLoading, error, isError }
}

export { useFetchHomeContent }
